<template>
  <div v-if="buttonLabel" class="categories-selector max-w-200px">
    <n-popover v-model:show="isPopupShown" trigger="click" :show-arrow="false" placement="bottom-start" :z-index="zIndex.navbarPopover">
      <template #trigger>
        <etg-button :size="buttonSize" type="text" icon="arrow-down" icon-position="right" :truncate-text="true" text-class="text-left">
          <component :is="buttonLabelTag">{{ buttonLabel }}</component>
        </etg-button>
      </template>
      <template #default>
        <div class="list w-240px max-h-480px py-2 rounded text-base scrollbar sm:w-360px">
          <template v-for="category in categoryUiList" :key="category.id">
            <locale-link :to="{ path: category.path, query: category.query }" @click="isPopupShown = false">
              <div class="py-3 px-5 hover:bg-gray-20 active:bg-gray-40 transition-colors">{{ category.name }}</div>
            </locale-link>
          </template>
          <scroll-mask />
        </div>
      </template>
    </n-popover>
  </div>
</template>

<script setup lang="ts">
import { NPopover } from 'naive-ui'

import { useAppStore } from '@/store/app'
import { useRegionStore } from '@/store/region'

import { zIndex } from '@/theme.config'

import { EdbCategoryType, type RegionCategory } from '@/types/api'

const appStore = useAppStore()
const regionStore = useRegionStore()
const route = useRoute()

const isPopupShown = ref(false)

const pageType = computed(() => route.query.type as string)
const buttonSize = computed(() => (appStore.isMobileScreen ? 'small' : 'medium'))

const { regionId } = useRegion()
const { category: categoryData } = useCategory()

const isThemesPage = computed(() => checkIfThemesPage(route.name))
const categories = computed(() => {
  const categoryMap: Partial<Record<EdbCategoryType, RegionCategory[] | undefined>> = {
    [EdbCategoryType.CategoryTypeTheme]: regionStore.regionInfo?.theme,
    [EdbCategoryType.CategoryTypeCuisine]: regionStore.regionInfo?.cuisine,
    [EdbCategoryType.CategoryTypeBrand]: regionStore.regionInfo?.brand,
    [EdbCategoryType.CategoryTypeLocation]: regionStore.regionInfo?.location,
  }

  return categoryMap[categoryData.value.type ?? EdbCategoryType.CategoryTypeCuisine] || []
})
const categoryRouteSubPath = computed(() => (isThemesPage.value ? 'themes' : 'categories'))
const categoryUiList = computed(() =>
  categories.value.map(c => ({
    ...c,
    path: `/regions/${regionId.value}/${categoryRouteSubPath.value}/${c.id}`,
    ...(!!pageType.value && { query: { type: pageType.value } }),
  }))
)
const buttonLabel = computed(() => categoryData.value.name)
const buttonLabelTag = computed(() => (appStore.isMobileScreen ? 'h1' : 'span'))
</script>
